import React, { useEffect, useState } from "react";
import anime from "animejs/lib/anime.es.js";
import RegisterModal from "../../components/Common/modals/RegisterModal";
import EnrollForm from "../../components/Enroll/EnrollForm";
import { ApiHook } from "../../hooks/apiHook";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

const MainEnroll = () => {
  const location = useLocation();
  let placement = location?.state?.parent;
  let position = location?.state?.position;
  const treePlan = location?.state?.treePlan ?? "new";

  const [showEnrollModal, setShowEnrollModal] = useState(false);
  const [modalType, setModalType] = useState("termsAndConditions");
  const [activeStep, setActiveStep] = useState(1);
  
  const { t } = useTranslation();

  const enrollFields = ApiHook.CallEnrollFields(treePlan);
  const userSelectedCurrency = useSelector(
    (state) => state.user?.selectedCurrency
  );

  const handleToggleEnrollModal = (type) => {
    setShowEnrollModal(!showEnrollModal);
    setModalType(type)
  };

  // animation for the enrollment steps
  const animateStepTransition = (nextStep) => {
    const containerElement = document.querySelector("#animation");
    const nextStepElement = document.querySelector(
      `.enroll-left-cnt-row:nth-child(${nextStep + 1})`
    );

    // Set initial position of the next step
    anime.set(containerElement, { opacity: 0 });
    if (nextStepElement) {
      anime.set(nextStepElement, { translateY: "100%" });
    }

    // Animate the next step in
    anime({
      targets: containerElement,
      opacity: [0, 1],
      duration: 1000,
      easing: "easeInOutQuad",
    });
    
    if (nextStepElement) {
      anime({
        targets: nextStepElement,
        translateY: "0%",
        duration: 500,
        easing: "easeInOutQuad",
      });
    }
  };

  // Default steps for enrollment
  const defaultSteps = [
    { step: 1, label: "select_sponsor_and_position" },
    { step: 2, label: "pick_your_products" },
    { step: 3, label: "payment" }
  ];

  const enrollmentSteps = /* enrollFields?.data?.registrationSteps || */ defaultSteps;

  return (
    <>
      <div className="page_head_top">{t("enroll_to_new_plan")}</div>
      <div className="container ">
        <div className="register_row align-items-center justify-content-center">
          <div className="main-regsiter-left-section">
            <div className="register-left-cnt-row opacity-1">
              <h2>{t("enroll_now")}</h2>
            </div>
            {enrollmentSteps?.map((step, index) => (
              <div
                key={index}
                className={`register-left-cnt-row enroll-left-cnt-row ${step.step === activeStep ? "active" : ""}`}
              >
                <span>{step.step}</span> {t(`${step.label}`)}
              </div>
            ))}
          </div>
          <EnrollForm
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            handleToggleEnrollModal={handleToggleEnrollModal}
            animateStepTransition={animateStepTransition}
            data={enrollFields?.data}
            currency={userSelectedCurrency}
            placement={placement}
            position={position}
            defaultSteps={defaultSteps}
          />
        </div>
      </div>
      <RegisterModal
        show={showEnrollModal}
        handleClose={handleToggleEnrollModal}
        data={modalType === "termsAndConditions" ? enrollFields?.data?.termsAndCondition?.termsAndConditions : enrollFields?.data?.refundPolicy?.refundPolicy}
        type={modalType}
      />
    </>
  );
};

export default MainEnroll;